import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'

import './index.css';

import Editor from './Editor';
// import register from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';

import state from './reducers/initialState'
import { debugHelper } from './utilities'

const { beta } = state.editor
const store = configureStore()

// dev
window.store = store.getState
window.getState = store.getState
window.debugHelper = debugHelper

if(beta) debugHelper()

ReactDOM.render(
  <Provider store={ store }>
    <Editor />
  </Provider>,
  document.getElementById('root')
);
// register();
unregister();

/**
 * TODO
 *
 * __editor firmware updating: ignore 'deviceready' message after firmware
 *
 * __editor NumberInput: allow entry of '-1'
 *
 * __editor preset version: if version is different, add new param
 *
 * __editor PropTypes: add PropTypes
 *
 * ___editor responsive layout: cover 3 breakpoints for desktop, tablet, mobile
 *
 */
